import React from 'react';
import { KatIcon } from '@amzn/katal-react';
import { Pages, MetricKeys } from 'src/constants/metrics';
import clickMetric from 'src/utils/clickRateMetricsPublisher';
import { THREAD_LISTING } from 'src/constants/pages';
import { useTranslation } from 'src/utils';
import { CategoryCardContainerLayout } from '../layouts/homepage/CategoryCardContainer';

export interface CategoryCardProps {
  categoryId: string;
  nameStringId: string;
}

export const categoryToIconMap: Record<string, KatIcon.Name> = {
  forums_cat_account_setup: 'folder_shared',
  forums_cat_create_and_manage_listings: 'view_list',
  forums_cat_fulfill_orders: 'assignment_turned_in',
  forums_cat_manage_inventory: 'assignment',
  forums_cat_manage_your_brand: 'business_center',
  forums_cat_grow_your_business: 'trending_up',
  forums_cat_manage_buyer_experience: 'shopping_basket',
  forums_cat_account_health: 'verified_user',
  forums_cat_news_and_announcements: 'speaker_notes',
  forums_cat_community_connections: 'people',
};

const CategoryCard: React.FC<CategoryCardProps> = ({
  nameStringId,
  categoryId,
}) => {
  const { t } = useTranslation();
  const iconName = categoryToIconMap[nameStringId];
  return (
    <CategoryCardContainerLayout
      categoryName={t(nameStringId)}
      icon={iconName && (
        <KatIcon
          className="mt-0.5 text-kat-nordic"
          name={iconName}
          size="tiny"
        />
      )}
      description={t(`${nameStringId}_desc`)}
      href={{ pathname: THREAD_LISTING, query: { 'categories[]': categoryId } }}
      onClick={() => clickMetric(Pages.home, MetricKeys.categoryCard, categoryId)}
    />
  );
};

export default CategoryCard;
